'use strict';

import MemoPlaceholder from '../components/MemoPlaceholder';

new MemoPlaceholder();
